export function isPropertyExist<T extends Object>(object: T, key: keyof T) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

export function isRealObject(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

export function isValidStatusCode(code: number) {
  return (
    (code >= 1000 && code <= 1014 && code !== 1004 && code !== 1005 && code !== 1006) ||
    (code >= 3000 && code <= 4999)
  );
}
